export default "__VITE_ASSET__n8n$cJNk__"